<template>
    <v-container>
        <v-layout align-center row v-if="error">
          <v-flex>
            <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
          </v-flex>
        </v-layout>
        <app-loading v-if="loading"></app-loading>
        <v-layout v-else row>
            <!--side panel of all chat convos-->
            <v-row class="hidden-sm-and-down">
                <v-navigation-drawer
                        absolute
                        permanent
                        left
                >
                    <template v-slot:prepend>
                        <v-container>
                          <!--number configuration-->
                          <v-layout>
<!--                            number card-->
                            <div v-if="numberDetails">
                              <v-expansion-panels>
<!--                                number configured-->
                                <v-expansion-panel v-if="numberConfigured">
                                  <v-expansion-panel-header>
                                    <avatar :username="numberDetails.friendlyName" class="white--text"></avatar>
                                    <div class="text-md-subtitle-2 ml-2">{{numberDetails.friendlyName}}</div>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content v-if="numberConfiguration">
                                    <div class="caption">Business Number</div>
                                    {{formatPhoneNumber(numberDetails.phoneNumber)}}
                                    <div class="caption">Inbound Forwarding</div>
                                    <v-list-item two-line>
                                      <v-list-item-content v-if="numberConfiguration.routingNotification">
                                        <v-list-item-title><v-icon class="success--text">fiber_manual_record</v-icon>Notifications on</v-list-item-title>
                                        <v-list-item-subtitle></v-list-item-subtitle>
                                      </v-list-item-content>
                                      <v-list-item-content v-if="!numberConfiguration.routingNotification">
                                        <v-list-item-title><v-icon class="error--text">fiber_manual_record</v-icon>Notifications off</v-list-item-title>
                                        <v-list-item-subtitle></v-list-item-subtitle>
                                      </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item two-line>
                                      <v-list-item-content>
                                        <v-list-item-title>SMS text</v-list-item-title>
                                        <v-list-item-subtitle>{{numberConfiguration.smsForwarding}}</v-list-item-subtitle>
                                      </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item two-line>
                                      <v-list-item-content>
                                        <v-list-item-title>Voice Call</v-list-item-title>
                                        <v-list-item-subtitle>
                                          {{numberConfiguration.callForwarding}}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </v-list-item>
                                    <div class="caption">Outbound Forwarding</div>
                                    <v-list-item three-line>
                                      <v-list-item-content>
                                        <v-list-item-title>Active Contact</v-list-item-title>
                                        <v-list-item-subtitle v-if="lastActiveContact">
                                          {{lastActiveContact.name}}
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle>
                                          {{numberConfiguration.lastActiveContact}}
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </v-list-item>
                                    <v-card-actions>
                                      <v-btn block text outlined class="blue--text" @click="configureNumberDialog = true">change</v-btn>
                                    </v-card-actions>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
<!--                                number is not configured-->
                                <v-expansion-panel v-else class="warning">
                                  <v-expansion-panel-header>
                                    <avatar username="?" class="white--text"></avatar>
                                    <div class="text-md-subtitle-2 ml-2">{{numberDetails.friendlyName}}</div>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-card-actions>
                                      <v-btn block class="black--text" @click="configureNumberDialog = true">Configure number</v-btn>
                                    </v-card-actions>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </div>
                          </v-layout>
                          <!--dial pad dialog-->
                          <v-layout>
                            <v-btn
                                :loading="loading"
                                :disabled="loading"
                                color="blue"
                                class="ma-2 white--text"
                                @click="dialPadDialog = true"
                                rounded
                            >
                              <v-icon>call</v-icon>
                              Dial Pad
                              <v-icon right dark>dialpad</v-icon>
                            </v-btn>
                          </v-layout>
                          <!-- search bar-->
                          <v-autocomplete
                              v-model="selectedUser"
                              :items="convoUsers"
                              label="Search Convo"
                              prepend-icon="search"
                              hide-details
                              hide-selected
                              single-line
                              clearable
                          ></v-autocomplete>
                        </v-container>
                    </template>
                    <v-divider></v-divider>
                    <!--users list-->
                    <v-list two-line>
                        <v-list-item
                                v-for="item in convos"
                                :key="item.phoneNumber"
                                @click="openMessage(item)"
                        >
                            <v-list-item-avatar>
                                <avatar class="white--text" :username="item.name"></avatar>
                            </v-list-item-avatar>


                            <v-list-item-content class="text-xs-left">
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                <v-list-item-subtitle>{{item.lastMessage}}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action v-if="item.hasScheduledSMS">
                                <v-icon class="blue--text">schedule_send</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-navigation-drawer>
            </v-row>
          <!--no user toolbar-->
          <v-flex xs12 sm12 offset-md-2 v-if="!selectedConvo">
            <v-main>
              <!--selected user toolbar-->
              <v-toolbar color="success lighten-3" dense>
                <v-toolbar-title>
                  <v-btn
                      :loading="loading"
                      :disabled="loading"
                      color="blue"
                      class="ma-2 white--text"
                      @click="addNewContactDialog = true"
                  >
                    <v-icon>add</v-icon>
                    <v-icon large>person</v-icon>
                    Add contact
                  </v-btn>
                </v-toolbar-title>
              </v-toolbar>
              <v-card>
                <v-card-text class="text-center">
                  <div class="body-1">No contacts available.</div>
                  <div class="body-1">Add contact to start conversations!</div>
                </v-card-text>
              </v-card>
            </v-main>
          </v-flex>
            <!--messaging ui-->
            <v-flex xs12 sm12 offset-md-2 v-if="selectedConvo">
                    <v-main>
                        <!--selected user toolbar-->
                        <v-toolbar color="success lighten-3" dense>
                            <v-toolbar-title>
                                <v-btn  @click="usersListDialog = true" dark class=" white hidden-md-and-up">
                                  <v-icon class="blue--text" dark>contacts</v-icon>
                                  <v-icon class="blue--text" dark>dialpad</v-icon>
                                </v-btn>
                                <v-btn class="ml-1" @click="toUserProfile(selectedConvo.phoneNumber)">
                                    <v-icon >person</v-icon>
                                    {{selectedConvo.name}}
                                </v-btn>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!--open call dialog-->
                            <v-btn outlined @click="openPhoneDialog" class="blue--text" icon>
                                <v-icon large>call</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-toolbar dense v-if="selectedConvo.activeBooking">
                            <v-toolbar-title>
                                <h5 @click="routeToOrder(selectedConvo.activeBooking)">Active Order: {{selectedConvo.activeBooking}}</h5>
                            </v-toolbar-title>
                        </v-toolbar>
                        <div v-else>
<!--                            <create-order></create-order>-->
                        </div>
                        <!--message box-->
                        <v-container fluid>
                            <!--send text message-->
                            <v-flex xs12 sm6 offset-sm3>
                                <v-textarea
                                        outlined
                                        label="New Text"
                                        v-model="textMessage"
                                        color="blue"
                                ></v-textarea>
<!--                                image upload button-->
                                <v-layout row>
                                    <v-btn @click="loadContent" icon><v-icon>photo</v-icon></v-btn>
                                    <v-btn icon><v-icon>location_on</v-icon></v-btn>
                                </v-layout>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn :disabled="msgNotValid" outlined text @click="scheduleSMSDialog = true" class="blue--text">Schedule Send <v-icon>schedule_send</v-icon></v-btn>
                                    <v-btn :disabled="msgNotValid"  @click="sendText" class="blue white--text">send</v-btn>
                                </v-card-actions>
                            </v-flex>
<!--                           scheduled Messages-->
                          <v-expansion-panels v-if="selectedScheduledConvos.length !== 0">
                            <v-expansion-panel
                                v-for="(item,i) in selectedScheduledConvos"
                                :key="i"
                            >
                              <v-expansion-panel-header>
                                <div v-if="item.direction === 'scheduled'">
                                  <v-icon class="blue--text">schedule_send</v-icon>
                                </div>
                                <v-container>
                                  <div>{{item.text}}</div>
                                  <div v-if="item.mediaUrl">
                                    <v-icon>photo</v-icon>
                                  </div>
                                </v-container>

                              </v-expansion-panel-header>

                              <v-expansion-panel-content>
                                <!--auto detect date and time-->
                                <v-layout v-if="item.dialogFlowAgent">
                                  <v-btn v-if="item.dialogFlowAgent"
                                         @click="addText(item.dialogFlowAgent.response.fulfillmentText)"
                                         text outlined rounded
                                         class="black--text">
                                    {{item.dialogFlowAgent.response.fulfillmentText.slice(0,8)}}</v-btn>
                                  <v-card-text v-if="!loading">
                                    <v-btn
                                        :disabled="!id"
                                        v-if="item.dialogFlowAgent.response.intent.displayName === 'meetup_date'"
                                        text outlined
                                        rounded
                                        class="blue--text"
                                        @click="addScheduleDate(item)"
                                    >edit <v-icon>event</v-icon></v-btn>
                                    <v-btn
                                        :disabled="!id"
                                        v-if="item.dialogFlowAgent.response.intent.displayName === 'meetup_date'"
                                        text outlined rounded
                                        class="blue--text"
                                        @click="addScheduleTime(item)"
                                    >edit <v-icon>timer</v-icon></v-btn>
                                    <h6 class="text-xs-left">
                                      {{moment(item.created)}}
                                    </h6>
                                  </v-card-text>
                                  <app-loading v-else></app-loading>
                                </v-layout>
                                <v-layout v-else>
                                  <v-card-text v-if="!loading">
                                    <h6 class="text-xs-left">
                                      {{moment(item.sendTime)}}
                                    </h6>
                                  </v-card-text>
                                </v-layout>
                                <v-layout>
                                  <v-card-text v-if="!loading">
                                    <v-btn @click="deleteScheduledText(item.id)"><v-icon>close</v-icon>delete</v-btn>
                                  </v-card-text>
                                </v-layout>
                                <v-layout v-if="item.mediaUrl">
                                  <v-img contain :src="item.mediaUrl" aspect-ratio="1.7"></v-img>
                                  <v-btn @click="saveImageUrl(item.mediaUrl)"  outlined class="blue--text">
                                    <v-icon>add_photo_alternate</v-icon>
                                  </v-btn>
                                </v-layout>
                              </v-expansion-panel-content>


                            </v-expansion-panel>
                          </v-expansion-panels>
                            <!--messages-->
                            <v-expansion-panels v-if="selectedConvos.length !== 0">
                                <v-expansion-panel
                                        v-for="(item,i) in selectedConvos"
                                        :key="i"
                                >
                                    <v-expansion-panel-header>
                                        <div v-if="item.direction === 'incoming'">
                                            <v-icon class="success--text">call_received</v-icon>
                                        </div>
                                        <div v-if="item.direction === 'outgoing'">
                                            <v-icon class="blue--text">call_made</v-icon>
                                        </div>
                                        <v-container>
                                            <div>{{item.text}}</div>
                                            <div v-if="item.mediaUrl">
                                                <v-icon>photo</v-icon>
                                            </div>
                                        </v-container>

                                    </v-expansion-panel-header>

                                    <v-expansion-panel-content>
                                        <!--auto detect date and time-->
                                        <v-layout v-if="item.dialogFlowAgent">
                                            <v-btn v-if="item.dialogFlowAgent"
                                                   @click="addText(item.dialogFlowAgent.response.fulfillmentText)"
                                                   text outlined rounded
                                                   class="black--text">
                                                {{item.dialogFlowAgent.response.fulfillmentText.slice(0,8)}}</v-btn>
                                            <v-card-text v-if="!loading">
                                                <v-btn
                                                        :disabled="!id"
                                                        v-if="item.dialogFlowAgent.response.intent.displayName === 'meetup_date'"
                                                        text outlined
                                                        rounded
                                                        class="blue--text"
                                                        @click="addScheduleDate(item)"
                                                >edit <v-icon>event</v-icon></v-btn>
                                                <v-btn
                                                        :disabled="!id"
                                                        v-if="item.dialogFlowAgent.response.intent.displayName === 'meetup_date'"
                                                        text outlined rounded
                                                        class="blue--text"
                                                        @click="addScheduleTime(item)"
                                                >edit <v-icon>timer</v-icon></v-btn>
                                                <h6 class="text-xs-left">
                                                    {{moment(item.created)}}
                                                </h6>
                                            </v-card-text>
                                            <app-loading v-else></app-loading>
                                        </v-layout>
                                      <v-layout v-else>
                                        <v-card-text v-if="!loading">
                                          <h6 class="text-xs-left">
                                            {{moment(item.created)}}
                                          </h6>
                                        </v-card-text>
                                      </v-layout>
                                        <v-layout v-if="item.mediaUrl">
                                            <v-img contain :src="item.mediaUrl" aspect-ratio="1.7"></v-img>
                                            <v-btn @click="saveImageUrl(item.mediaUrl)"  outlined class="blue--text">
                                                <v-icon>add_photo_alternate</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-expansion-panel-content>


                                </v-expansion-panel>
                            </v-expansion-panels>
                            <v-flex v-else>
                                <div>No Recent Messages</div>
                            </v-flex>
<!--                            Load more job-->
                            <v-flex class="mt-6">
                                <v-btn block text outlined class="blue--text" @click="loadMoreMsg(selectedConvo)">Load More</v-btn>
<!--                              <v-btn block text outlined class="blue&#45;&#45;text" @click="testFunction(selectedConvo)">Test Function</v-btn>-->
                            </v-flex>
                        </v-container>
                    </v-main>
            </v-flex>
        </v-layout>

      <v-dialog v-model="usersListDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-card-title>
                    <v-btn icon @click="usersListDialog = false"><v-icon>cancel</v-icon></v-btn>
                    Recents
                </v-card-title>
                <template>
                    <v-container>
                      <v-layout>
                        <!--                            number card-->
                        <v-col cols="12" sm="12" md="12" v-if="numberDetails">
                          <v-expansion-panels>
                            <!--                                number configured-->
                            <v-expansion-panel v-if="numberConfigured">
                              <v-expansion-panel-header>
<!--                                <avatar :username="numberDetails.friendlyName" class="white&#45;&#45;text"></avatar>-->
                                <v-icon>contact_phone</v-icon>
                                <div class="text-md-subtitle-2">{{numberDetails.friendlyName}}</div>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content v-if="numberConfiguration">
                                <div class="caption">Business Number</div>
                                {{formatPhoneNumber(numberDetails.phoneNumber)}}
                                <div class="caption">Inbound Forwarding</div>
                                <v-list-item two-line>
                                  <v-list-item-content v-if="numberConfiguration.routingNotification">
                                    <v-list-item-title><v-icon class="success--text">fiber_manual_record</v-icon>Notifications on</v-list-item-title>
                                    <v-list-item-subtitle></v-list-item-subtitle>
                                  </v-list-item-content>
                                  <v-list-item-content v-if="!numberConfiguration.routingNotification">
                                    <v-list-item-title><v-icon class="error--text">fiber_manual_record</v-icon>Notifications off</v-list-item-title>
                                    <v-list-item-subtitle></v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item two-line>
                                  <v-list-item-content>
                                    <v-list-item-title>SMS text</v-list-item-title>
                                    <v-list-item-subtitle>{{numberConfiguration.smsForwarding}}</v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item two-line>
                                  <v-list-item-content>
                                    <v-list-item-title>Voice Call</v-list-item-title>
                                    <v-list-item-subtitle>
                                      {{numberConfiguration.callForwarding}}
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                                <div class="caption">Outbound Forwarding</div>
                                <v-list-item three-line>
                                  <v-list-item-content>
                                    <v-list-item-title>Active Contact</v-list-item-title>
                                    <v-list-item-subtitle v-if="lastActiveContact">
                                      {{lastActiveContact.name}}
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                  <v-list-item-action>
                                    {{numberConfiguration.lastActiveContact}}
                                  </v-list-item-action>
                                </v-list-item>
                                <v-card-actions>
                                  <v-btn block text outlined class="blue--text" @click="configureNumberDialog = true">change</v-btn>
                                </v-card-actions>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                            <!--                                number is not configured-->
                            <v-expansion-panel v-else class="warning">
                              <v-expansion-panel-header>
                                <avatar username="?" class="white--text"></avatar>
                                <div class="text-md-subtitle-2 ml-2">{{numberDetails.friendlyName}}</div>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-card-actions>
                                  <v-btn block class="black--text" @click="configureNumberDialog = true">Configure number</v-btn>
                                </v-card-actions>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-col>
                      </v-layout>
<!--                      search convos-->
                        <v-layout>
                            <v-col cols="12" sm="12" md="12">
                                <v-autocomplete
                                        v-model="selectedUser"
                                        :items="convoUsers"
                                        label="Search Convo"
                                        hide-details
                                        hide-selected
                                        single-line
                                        clearable
                                ></v-autocomplete>
                            </v-col>
                        </v-layout>
                      <!--dial pad dialog-->
                        <v-layout>
                            <v-col cols="10" sm="10" md="10">
                              <v-btn
                                  :loading="loading"
                                  :disabled="loading"
                                  color="blue"
                                  class="ma-2 white--text"
                                  @click="dialPadDialog = true"
                                  rounded
                              >
                                <v-icon>call</v-icon>
                                Dial Pad
                                <v-icon right dark>dialpad</v-icon>
                              </v-btn>

                            </v-col>
                        </v-layout>
                    </v-container>
                </template>

                <v-divider></v-divider>
                <!--users list-->
                <v-list two-line>
                    <v-list-item
                            v-for="item in convos"
                            :key="item.phoneNumber"
                            @click="openMessage(item)"
                    >
                        <v-list-item-avatar>
                            <avatar class="white--text" :username="item.name"></avatar>
                        </v-list-item-avatar>


                        <v-list-item-content class="text-xs-left">
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                            <v-list-item-subtitle>{{item.lastMessage}}</v-list-item-subtitle>
                        </v-list-item-content>

                      <v-list-item-action v-if="item.hasScheduledSMS">
                        <v-icon class="blue--text">schedule_send</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>
      <v-dialog v-model="dialPadDialog"
                persistent
                fullscreen  transition="dialog-bottom-transition"
                class="white"
      >
        <v-card>
          <v-container>
            <v-layout align-center column>
              <v-btn large text class="black--text" @click="dialPadDialog = false"><v-icon large>close</v-icon>close</v-btn>
              <v-flex xs12 sm12>
                <dial-pad
                        @contactDialogValue="this.dialPadAction"
                        @numberFound="dialPadNumber"
                        @callFromDialPad="callFromDialPad"
                    ></dial-pad>
              </v-flex>
              <v-flex xs12 sm12 offset-md-2 class="mt-5">
<!--                to segments-->
                <v-card class="mb-5">
                  <v-card-title><v-icon class="mr-2">groups</v-icon> Group Message </v-card-title>
                  <v-card-actions>
                    <v-btn outlined class="blue--text" @click="$router.push('/segments/' + user.uid +'/'+ phoneNumber)">Create new segment</v-btn>
                  </v-card-actions>
                </v-card>
                <!--calls list-->
              <v-card>
                <v-card-title><v-icon class="mr-2">call</v-icon>Recent Calls</v-card-title>
                <v-card-text>
                  <v-list two-line>
                    <v-list-item
                        v-for="item in calls"
                        :key="item.phoneNumber"
                        @click="openMessage(item)"
                    >
                      <v-list-item-avatar>
                        <avatar class="white--text" :username="item.name"></avatar>
                      </v-list-item-avatar>


                      <v-list-item-content class="text-xs-left">
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{moment(item.lastActive)}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="phoneDialog"
                ref="dialog"
                persistent
                width="290px"
      >
        <v-card>
          <v-card-title>
            <div class="white black--text text-xs-center font-weight-thin display-1">Call Forwarding</div>

            <div v-if="loading" class="headline font-weight-light">
              Setting outbound routing...
            </div>

          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <app-loading v-if="loading"></app-loading>
            <div v-if="!loading" class="subtitle-1 font-weight-light">
              <div>{{numberConfiguration.friendlyRoutingName}} {{formatPhoneNumber(numberConfiguration.callForwarding)}}</div>
              <div><v-icon>arrow_downward</v-icon></div>
              <div v-if="numberDetails">{{numberDetails.friendlyName}} {{formatPhoneNumber(numberDetails.phoneNumber)}}</div>
              <div><v-icon>arrow_downward</v-icon></div>
              <div v-if="lastActiveContact">{{lastActiveContact.name}} {{formatPhoneNumber(numberConfiguration.lastActiveContact)}}</div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="configureNumberDialog = true"
            >
              <v-icon>settings</v-icon> Change
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="phoneDialog = false" text>cancel</v-btn>
            <v-btn v-if="!loading" @click="dialNumber" class="blue white--text">Dial</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="imageUploadDialog"
                  ref="dialog"
                  persistent
                  width="500px"
        >
            <v-card>
                <img-uploader :id="id" @imageLinkFound="addImageLink" @removeImage="removeImageLink"></img-uploader>
                <v-card-text v-if="mediaUrl">
                    <v-img contain :src="mediaUrl" aspect-ratio="1.7"></v-img>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelImageUpload">cancel</v-btn>
                    <v-btn class="blue white--text" @click="sendText">send <v-icon>send</v-icon></v-btn>
                </v-card-actions>

                <template>
                    <v-row>
                        <v-col cols="12" sm="6" offset-sm="3">
                            <v-card>
                                <v-container fluid>
                                    <v-row>
                                        <v-col
                                                v-for="n in content"
                                                :key="n.created"
                                                class="d-flex child-flex"
                                                cols="4"
                                        >
                                            <v-card flat tile class="d-flex">
                                                <v-img
                                                        :src="n.imageUrl"
                                                        aspect-ratio="1"
                                                        class="grey lighten-2"
                                                        @click="selectImgFromContent(n.imageUrl)"
                                                >
                                                    <template v-slot:placeholder>
                                                        <v-row
                                                                class="fill-height ma-0"
                                                                align="center"
                                                                justify="center"
                                                        >
                                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                        </v-row>
                                                    </template>
                                                </v-img>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>

            </v-card>
        </v-dialog>
      <v-dialog v-model="addNewContactDialog"
                ref="dialog"
                persistent
                width="290px"
      >
        <v-card
            class="mx-auto"
            max-width="500"
        >
          <v-card-title class="text-h6 font-weight-regular justify-space-between">
            <div class="white black--text text-xs-center font-weight-thin headline">{{ newContactDialogTitle }}</div>
          </v-card-title>

          <v-window v-model="newContactDialogStep">
            <v-window-item :value="1">
              <v-card-text>
                <v-text-field
                    prepend-icon="person"
                    v-model="newContactName"
                    :rules="nameRules"
                    label="Name"
                ></v-text-field>

                <v-text-field
                    prepend-icon="email"
                    name="login"
                    v-model="newContactEmail"
                    :rules="emailRules"
                    label="Email"
                    type="text">
                </v-text-field>
                <!--                    phone number-->
                <v-text-field-simplemask
                    v-model="randomNumber"
                    label="Phone number"
                    v-bind:properties="{
                      clearable: true,
                      'prepend-icon': 'phone'
                     }"
                    v-bind:options="{
                      inputMask: '(###) ###-####',
                      outputMask: '###########',
                      alphanumeric: true}"
                />
              </v-card-text>
            </v-window-item>

            <v-window-item :value="2">
              <v-card-text>
                <div v-if="newContactName !== ''" class="text-h5">{{newContactName}}</div>
                <div v-if="randomNumber !== ''" class="text-h5">{{randomNumber}}</div>
                <div v-if="newContactEmail !== ''" class="text-h6 font-weight-light">{{newContactEmail}}</div>
<!--                save contact-->
                <v-btn :disabled="randomNumberNotValid" @click="addNewContact" block class="blue--text mt-3" outlined>
                  <v-icon>import_contacts</v-icon>
                  Save contact only</v-btn>
                <v-textarea
                    class="mt-3"
                    outlined
                    label="New Text"
                    v-model="textMessage"
                ></v-textarea>
                <v-btn block :disabled="randomMsgNotValid" @click="addNewContact" class="blue--text" outlined>
                  <v-icon>sms</v-icon>
                  Send text</v-btn>
              </v-card-text>
            </v-window-item>
            <v-window-item :value="3">
              <div class="pa-4 text-center">
                <h3 v-if="!componentLoading" class="text-h6 font-weight-light mb-2">
                  <v-icon>check</v-icon> Contact Saved
                </h3>
                <v-progress-circular
                    v-else
                    indeterminate
                    class="blue--text"
                ></v-progress-circular>

              </div>
            </v-window-item>
          </v-window>

          <v-divider></v-divider>

          <v-card-actions v-if="newContactDialogStep === 3">
            <v-btn
                text
                @click="newContactDialogStep--"
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="addNewContactDialog = false">close</v-btn>
          </v-card-actions>
          <v-card-actions v-if="newContactDialogStep !== 3">
            <v-btn
                v-if="newContactDialogStep !== 1"
                text
                @click="newContactDialogStep--"
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="addNewContactDialog = false">cancel</v-btn>
            <v-btn
                :disabled="randomNumberNotValid"
                v-if="newContactDialogStep !== 2"
                color="blue white--text"
                depressed
                @click="newContactDialogStep++"
            >
              Next
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="configureNumberDialog"
                ref="dialog"
                persistent
                width="auto"
      >
        <v-card
            class="mx-auto"
            max-width="800"
        >
          <v-card-title class="text-h6 font-weight-regular justify-space-between">
            <div class="white black--text text-xs-center font-weight-thin headline">Number Configuration</div>
          </v-card-title>
<!--          phonenumber and friendly name title-->
          <v-card-title  v-if="numberDetails">
            <div>{{numberDetails.friendlyName}}</div>
          </v-card-title>
          <v-card-subtitle>
            <div class="white black--text text-xs-center font-weight-light subtitle-1">{{formatPhoneNumber(numberDetails.phoneNumber)}}</div>
          </v-card-subtitle>
          <v-card-title v-if="numberDetails">
            <v-text-field
                clearable
                label="Friendly Name"
                v-model="numberDetails.friendlyName"
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <div v-if="!numberConfigured" class="warning--text text-h6"> Set default forwarding!</div>
            <div>Recipient name:</div>
            <v-text-field
                prepend-icon="person"
                v-model="numberConfiguration.friendlyRoutingName"
                label="Name"
            ></v-text-field>
            <div>Inbound forwarding
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      class="black--text"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      icon
                      text
                  >
                    <v-icon>info_outline</v-icon>
                  </v-btn>
                </template>
                <span>Anyone calling or texting will get forwarded to following number</span>
              </v-tooltip>
            </div>
            <div class="subtitle-1">SMS text:</div>
            <v-text-field-simplemask
                v-model="numberConfiguration.smsForwarding"
                label="Phone number"
                v-bind:properties="{
                      clearable: true,
                      'prepend-icon': 'phone'
                     }"
                v-bind:options="{
                      inputMask: '(###) ###-####',
                      outputMask: '###########',
                      alphanumeric: true}"
            />
            <v-switch
                v-model="numberConfiguration.routingNotification"
                color="blue"
                :label="`Receive SMS notifications: ${numberConfiguration.routingNotification.toString()}`"
            ></v-switch>
            <div class="subtitle-1">Voice call:</div>
            <v-text-field-simplemask
                v-model="numberConfiguration.callForwarding"
                label="Phone number"
                v-bind:properties="{
                      clearable: true,
                      'prepend-icon': 'phone'
                     }"
                v-bind:options="{
                      inputMask: '(###) ###-####',
                      outputMask: '###########',
                      alphanumeric: true}"
            />

            <div>
              Outbound forwarding
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      class="black--text"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      icon
                      text
                  >
                    <v-icon>info_outline</v-icon>
                  </v-btn>
                </template>
                <span>Calls and text from above phone number is forwarded to this number. Auto updates after any new inbound calls or texts</span>
              </v-tooltip>
            </div>
            <div class="subtitle-1">Voice & Text:</div>
              <v-list-item-content>
                <v-list-item-subtitle v-if="lastActiveContact">
                  {{lastActiveContact.name}}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  {{numberConfiguration.lastActiveContact}}
                </v-list-item-subtitle>
              </v-list-item-content>

            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                  v-model="outboundForward"
                  :items="convoUsers"
                  label="Change forwarding"
                  hide-details
                  hide-selected
                  single-line
                  clearable
              ></v-autocomplete>
            </v-col>
          </v-card-text>

          <v-card-actions >
            <v-spacer></v-spacer>
            <v-btn
                text
                @click="configureNumberDialog = false"
            >close</v-btn>
            <v-btn text class="blue white--text" :disabled="numberConfiguration.smsForwarding === ''" @click="setNumberConfiguration">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="scheduleSMSDialog"
                ref="dialog"
                persistent
                width="580px"
      >
        <v-card>
          <v-card-title

              justify="space-around"
          >
            <div v-if="scheduleSMSTime !== ''">Scheduled Time: </div>
            <div>{{scheduleSMSTime}} - {{scheduleSMSDate}}</div>
          </v-card-title>
          <v-card-text>
            <v-row

                justify="space-around"
                align="center"
            >
              <v-time-picker
                  v-if="scheduleSMSTime === ''"
                  v-model="scheduleSMSTime"
                  ampm-in-title
                  color="blue"
                  header-color="blue"
              ></v-time-picker>
              <v-btn v-if="scheduleSMSTime !== ''" @click="scheduleSMSTime = ''" text> Pick Time</v-btn>
              <v-date-picker v-if="scheduleSMSTime !== ''"
                             v-model="scheduleSMSDate"
                             color="blue"
                             header-color="blue"
              ></v-date-picker>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="scheduleSMSDialog = false">cancel</v-btn>
            <v-btn :disabled="!scheduledTimeDateValid" @click="sendScheduledText" class="blue--text">Schedule Send <v-icon>send</v-icon></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>
<script>
import {collection, query, where, doc, getDoc, getDocs, setDoc, addDoc, updateDoc, onSnapshot, deleteDoc,Timestamp} from "firebase/firestore";
    import Avatar from "vue-avatar"
    import moment from "moment"
    import { v1 as uuidv1 } from 'uuid';
    export default {
      components: {
        Avatar
      },
      props: ["phoneNumber"],
      data () {
        return {
          nameRules: [
            v => (v && v.length <= 25) || 'Name must be less than 10 characters',
          ],
          emailRules: [
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
          ],
          newContactName: '',
          newContactEmail: '',
          newContactDialogStep: 1,
          numberDetails: null,
          addNewContactDialog: false,
          usersListDialog: false,
          convos: [],
          selectedConvo: undefined,
          selectedConvos: [],
          selectedScheduledConvos: [],
          searchItem: '',
          selectedUser: '',
          convoUsers: [],
          id: uuidv1(),
          textMessage: '',
            phoneDialog: false,
            imageUploadDialog: false,
            mediaUrl: undefined,
            content: [],
            randomUser: false,
            randomNumber: '',
          componentLoading: true,
          configureNumberDialog: false,
          numberConfigured: false,
          numberConfiguration: {
            friendlyRoutingName: '',
            routingNotification: true,
            smsForwarding: '',
            callForwarding: '',
            lastActiveContact: ''
          },
          lastActiveContact: undefined,
          outboundForward: '',
          dialPadDialog: false,
          numberFromDialPad: '',
          calls: [],
          scheduleSMSDialog: false,
          scheduleSMSTime: '',
          scheduleSMSDate: ''
        }
      },
      computed: {
        scheduledTimeDateValid () {
          return this.scheduleSMSTime !== '' && this.scheduleSMSDate !== ''
        },
        user () {
          return this.$store.getters.user
        },
        newContactDialogTitle () {
          if (this.newContactDialogStep) {
            switch (this.newContactDialogStep) {
              case 1: return 'Contact details'
              case 2: return 'Create contact'
            }
          } else return null

        },
        filteredList () {
          if(this.convos.length !==0) {
            return this.convos.filter((item) => {
              return item.name.toLowerCase().match(this.searchItem.toLowerCase())
            })
          }
          return []
        },
        randomNumberNotValid () {
          if (this.randomNumber) {
            return this.randomNumber.length !== 10;
          } else return true
        },
        randomMsgNotValid () {
          if (this.randomNumber) {
            return !((this.randomNumber.length === 10) && (this.textMessage !== ''));
          } else return true
        },
        msgNotValid () {
          return this.textMessage === '';
        },
        momentShortDate () {
          return (date) => {
            //console.log(date)
            let dateSince = Date.now() - date
            //console.log(dateSince)
            let day
            if (dateSince < 86400) {
              day = moment(date).format('hh:mm A')
            }
            // day = moment(date).format('ddd, MMM Do, hh:mm:ss A')
            return day
          }
        },
        moment () {
          return (date) => {
            let day = moment(date).format('ddd, MMM Do, hh:mm:ss A')
            return day
          }
        },
        error () {
          return this.$store.getters.error
        },
        loading () {
          return this.$store.getters.loading
        }
      },
      created () {
        let userId = this.$route.query.userId
        this.$store.dispatch('setLoading', true)
        //console.log(userId)
        let db = this.$store.state.db
        // fetches numbers details
        let numberRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber)
        onSnapshot(numberRef, doc => {
              if (doc.exists) {
                let data = doc.data()
                console.log(data)
                this.numberDetails = data
                if(data.numberConfiguration){
                  this.numberConfigured = true
                  this.numberConfiguration = data.numberConfiguration
                  this.fetchLastActiveContact()
                } else {
                  this.numberConfigured = false
                  this.configureNumberDialog = true
                }
                this.$store.dispatch('setLoading', false)
              }
            },error => {
              //console.log(error)
              this.$store.dispatch('setError', error)
              this.$store.dispatch('setLoading', false)
            })

        // fetches contacts associated by this number
        let smsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/'+ this.phoneNumber + '/sms')
        onSnapshot(smsRef, res => {
              if (res && res.empty !== true) {
                let convos = []
                let convoUsers = []
                res.forEach(doc => {
                  // console.log(doc.data())
                  let data = doc.data()
                  convos.push(data)
                })
                this.convos = convos.sort((convoA, convoB) => {
                  return convoB.lastActive - convoA.lastActive
                })
                this.convos.forEach(convo => {
                  convoUsers.push(convo.name)
                })
                this.convoUsers = convoUsers
                // open contact coming back from profile view
                      if (userId) {
                          let userPhoneNumber = '+' + userId.substring(1)
                          //console.log(userPhoneNumber)
                         let convoUser = convos.find(user => {
                              return user.phoneNumber === userPhoneNumber
                          })
                         // console.log(convoUser)
                          this.openMessage(convoUser)
                      } else {
                          // console.log(convos[0])
                        // open last active contact
                          this.openMessage(convos[0])
                      }
                this.$store.dispatch('setLoading', false)
              } else {
                this.convoUsers = []
                this.$store.dispatch('setLoading', false)
              }
        })

        //load phone calls
        let userCallRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/calls/')
        onSnapshot(userCallRef, res => {
              let calls = []
              res.docs.forEach(doc => {
                let callData = doc.data()
                callData.phoneNumber = doc.id
                //console.log(callData)
                calls.push(callData)
              })

              this.calls = calls.sort((callA, callB) => {
                return callB.lastActive - callA.lastActive
              })
              // console.log(this.calls)
              this.$store.dispatch("setLoading", false)
              this.usersListDialog = false
            })
        this.$store.dispatch('setLoading', false)
      },
      watch: {
        selectedUser (userName) {
          if (userName !== undefined) {
            let userObj = this.convos.find(user => {
              return user.name === userName
            })
            this.selectedConvo = userObj
              //console.log(userObj)
              this.openMessage(userObj)
          }
        },
        outboundForward (userName) {
          if (userName !== undefined) {
            let userObj = this.convos.find(user => {
              return user.name === userName
            })
            this.selectedConvo = userObj
            this.setOutboundForwarding()
          }
        }
      },
      methods: {
        formatPhoneNumber(phoneNumberString) {
          // console.log(phoneNumberString)
          let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
          let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
          if (match) {
            let intlCode = (match[1] ? '+1 ' : '');
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
          }
          return null;
        },
        addNewContact () {
          this.newContactDialogStep++
          this.componentLoading = true
          let userObj = {}
          userObj.name = this.newContactName
          userObj.connectedPhoneNumber = this.phoneNumber
          if (!this.randomNumberNotValid) {
            userObj.phoneNumber = '+1' + this.randomNumber
          }
          if (this.newContactEmail !== '') {
            userObj.email = this.newContactEmail
          }
          if (this.newContactName === '') {
            userObj.name = this.randomNumber
          }
          let db = this.$store.state.db
          return addDoc(collection(db, 'users', this.user.uid, 'contacts'), userObj, { merge: true })
          .then((docRef) => {
            userObj.contactId = docRef.id
            if (userObj.phoneNumber) {
              this.setContactSMSCallsRouting(userObj)
            } else {
              this.componentLoading = false
            }
          }).catch(err => {
            this.addNewContactDialog = false
            this.dispatch('setError', err)
          })

        },
        setContactSMSCallsRouting (contactData) {
          //console.log(contactData)
          let userObj = {...contactData}
          userObj.lastActive = Timestamp.now().toMillis()
          userObj.lastMessage = 'New Contact'
          // console.log(userObj)
          let db = this.$store.state.db
          let smsRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber, 'sms', userObj.phoneNumber)
          let voiceRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber, 'calls', userObj.phoneNumber)
          let userMsgsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/sms/' + userObj.phoneNumber + '/messages')
          let smsBody  = {
            created: Timestamp.now().toMillis(),
            direction: 'outgoing',
            id: uuidv1(),
            text: 'New Contact'
          }
          // check if text message available
          if (this.textMessage !== '') {
            userObj.lastMessage = this.textMessage
            smsBody.text = this.textMessage
            // add message to db
            return addDoc(userMsgsRef, {...smsBody})
            .then(() => {
            // set sms contact profile
              return setDoc(smsRef, userObj,  { merge: true })
            })
            .then(() => {
              //set voice contact profile
              return setDoc(voiceRef, userObj,  { merge: true })
            })
            .then(() => {
              let numberRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber)
              // set clients operator details
              let numberConfig = {...this.numberConfiguration}
              numberConfig.lastActiveContact = userObj.phoneNumber
              updateDoc(numberRef,{numberConfiguration: {...numberConfig}})
            })
            .then(() => {
              this.componentLoading = false
              this.addNewContactDialog = false
              this.newContactName = ''
              this.newContactEmail = ''
              this.textMessage =''
              this.newContactDialogStep = 1
              this.randomNumber = ''
            })
            .catch(err => {
               //console.log(err)
               this.$store.dispatch('setError', err)
            })
          } else {
            // set sms contact profile
            return setDoc(smsRef, userObj,  { merge: true })
                .then(() => {
                  //set voice contact profile
                  return setDoc(voiceRef, userObj,  { merge: true })
                })
                .then(() => {
                  this.componentLoading = false
                  this.addNewContactDialog = false
                  this.newContactName = ''
                  this.newContactEmail = ''
                  this.textMessage =''
                  this.newContactDialogStep = 1
                  this.randomNumber = ''

                })
                .catch(err => {
                  console.log(err)
                  this.$store.dispatch('setError', err)
                })
          }
        },
        callFromDialPad (phoneNumber) {
          this.dialPadDialog = false
          let contactNumber = '+1'+phoneNumber
          let db = this.$store.state.db
          // check if number exist
          let userMsgsRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/sms/' + contactNumber)
          // if number exist update last active only
          getDoc(userMsgsRef)
              .then(dbRes => {
                if (!dbRes.data()) {
                  let userObj = {}
                  userObj.name = contactNumber
                  userObj.connectedPhoneNumber = this.phoneNumber
                  userObj.phoneNumber = contactNumber
                  this.setContactSMSCallsRouting(userObj)
                }
                let numberRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber)
                // set clients operator details
                let numberConfig = {...this.numberConfiguration}
                numberConfig.lastActiveContact = contactNumber
                updateDoc(numberRef,{numberConfiguration: {...numberConfig}})
              })
              .then(() => {
                   this.phoneDialog = true
              })
              .catch(error => {
                console.log(error)
                this.$store.dispatch('setError', error)
                this.$store.dispatch('setLoading', false)
              })
        },
        addText (msg) {
          this.textMessage = msg
        },
        openMessage (user) {
          //console.log(user)
          let monthPastToday = Date.now() - 159200000
          let convos = []
          this.selectedConvo = user
          let db = this.$store.state.db
          let contactMsgsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/sms/' + user.phoneNumber + '/messages')
          let q = query(contactMsgsRef, where('created', '>', monthPastToday))
          return getDocs(q)
              .then(res => {
                //console.log(res)
                res.docs.forEach(doc => {
                  //console.log(doc.data())
                  convos.push(doc.data())
                })

                this.selectedConvos = convos.sort((convoA, convoB) => {
                  return convoB.created - convoA.created
                })
                // console.log(convos)
              })
              .then(() => {
                this.openSceduledMessage(user)
                this.$store.dispatch("setLoading", false)
                this.usersListDialog = false
              })
              .catch(err => {
                this.$store.dispatch('setError', err)
                this.$store.dispatch("setLoading", false)
                console.log(err)
              })

        },
        openSceduledMessage (user) {
          //console.log(user)
          let convos = []
          this.selectedConvo = user
          let db = this.$store.state.db
          let contactMsgsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/scheduledSMS/' + user.phoneNumber + '/messages/')
          let q = query(contactMsgsRef, where('direction', '==', 'scheduled'))
          return getDocs(q)
              .then(res => {
                //console.log(res)
                res.docs.forEach(doc => {
                  //console.log(doc.data())
                  convos.push(doc.data())
                })

                this.selectedScheduledConvos = convos.sort((convoA, convoB) => {
                  return convoB.created - convoA.created
                })
              })
              .catch(err => {
                this.$store.dispatch('setError', err)
                this.$store.dispatch("setLoading", false)
                console.log(err)
              })

        },
        sendText () {
          this.addNewContactDialog = false
          this.imageUploadDialog = false
          let id = uuidv1()
          let user = this.selectedConvo
          let time = Timestamp.now().toMillis()
          let db = this.$store.state.db
          let userSMSRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/sms/' + user.phoneNumber)
          let userMsgsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/sms/' + user.phoneNumber + '/messages')
          this.setOutboundForwarding()
          updateDoc(userSMSRef, {
            lastActive: time,
            lastMessage: this.textMessage
          })
          let outgoingMsg = {
            text: this.textMessage,
            created: time,
            id: id,
            direction: 'outgoing',
            //  direction: 'incoming' //change to outgoing before deploying
          }
          if (this.mediaUrl) {
            outgoingMsg.mediaUrl = this.mediaUrl
          }
          addDoc(userMsgsRef, {...outgoingMsg})
              .catch(err => {
                this.$store.dispatch('setError', err)
              })
          this.textMessage = ''
          this.phoneDialog = false
          this.mediaUrl = undefined

        },
        sendScheduledText () {
          let user = this.selectedConvo
          let timeDate = this.scheduleSMSTime + ' ' + this.scheduleSMSDate
          let timeStamp = moment(timeDate, 'HH:mm YYYY-MM-DD').valueOf()
          let msgObj = {
            sendTime: timeStamp,
            phoneNumber: user.phoneNumber,
            created: Date.now(),
            text: this.textMessage,
            direction: "scheduled",
            id: uuidv1(),
            provisionedNumber: this.phoneNumber
          }
          if (this.mediaUrl) {
            msgObj.mediaUrl = this.mediaUrl
          }
          if (!user.hasScheduledSMS) {
            user.hasScheduledSMS = 1
          } else {
            user.hasScheduledSMS += 1
          }
          let db = this.$store.state.db
          let scheduledSMSRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/scheduledSMS/' + user.phoneNumber + '/messages/' + msgObj.id)
          let userSMSRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/sms/' + user.phoneNumber)
          return setDoc(scheduledSMSRef, msgObj)
              .then(() => {
                return updateDoc(userSMSRef, user)
              })
              .then(() => {
                this.textMessage = ''
                this.scheduleSMSTime = ''
                this.scheduleSMSDate = ''
                this.scheduleSMSDialog = false
              })
              .catch(err => {
                this.$store.dispatch('setError', err)
              })
        },
        deleteScheduledText (id) {
          let user = this.selectedConvo
          let db = this.$store.state.db
          let scheduledSMSRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/scheduledSMS/' + user.phoneNumber + '/messages/' + id)
          let userSMSRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/sms/' + user.phoneNumber)
          if (user.hasScheduledSMS < 1) {
            user.hasScheduledSMS = 0
          } else {
            user.hasScheduledSMS -= 1
          }
          return updateDoc(userSMSRef, user)
          .then(()=>{
            return deleteDoc(scheduledSMSRef)
          })
          .then(() => {
            return this.openSceduledMessage()
          })
        },
        toUserProfile(phoneNumber) {
          this.$router.push('/numberPortal/' + this.phoneNumber + '/' + phoneNumber)
        },
        setNumberConfiguration () {
          let db = this.$store.state.db
          let numberRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber)
          let numberConfig = {...this.numberConfiguration}
          if (this.numberConfiguration.callForwarding) {
            numberConfig.callForwarding = this.numberConfiguration.callForwarding
          } else {numberConfig.callForwarding = this.numberConfiguration.smsForwarding}
          updateDoc(numberRef,{numberConfiguration: {...numberConfig}, friendlyName: this.numberDetails.friendlyName})
          this.configureNumberDialog = false
        },
        openPhoneDialog () {
          this.phoneDialog = true
          this.callClient()
        },
        callClient () {
          // console.log(this.user.phoneNumber)
          this.$store.dispatch('setLoading', true)
          let db = this.$store.state.db
          let numberRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber)
          this.phoneDialog = true
          // check clients operator details
          let numberConfig = {...this.numberConfiguration}
          numberConfig.lastActiveContact = this.selectedConvo.phoneNumber
          updateDoc(numberRef,{numberConfiguration: {...numberConfig}})
          this.$store.dispatch('setLoading', false)

        },
        dialNumber () {
          this.phoneDialog = false
          window.location.href = 'tel://' + this.numberDetails.phoneNumber
        },
        setOutboundForwarding () {
          // console.log(this.user.phoneNumber)
          let db = this.$store.state.db
          let numberRef = doc(db, 'users', this.user.uid, 'provisionedNumbers', this.phoneNumber)
          // check clients operator details
          let numberConfig = {...this.numberConfiguration}
          numberConfig.lastActiveContact = this.selectedConvo.phoneNumber
          updateDoc(numberRef,{numberConfiguration: {...numberConfig}})
        },
        loadMoreMsg (user) {
          let convos = []
          this.selectedConvo = user
          let db = this.$store.state.db
          let userMsgsRef = collection(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/sms/' + user.phoneNumber + '/messages')
              getDocs(userMsgsRef)
              .then(res => {
                res.docs.forEach(doc => {
                  //console.log(doc.data())
                  convos.push(doc.data())
                })

                this.selectedConvos = convos.sort((convoA, convoB) => {
                  return convoB.created - convoA.created
                })
                // console.log(convos)
              })
              .then(() => {
                this.$store.dispatch("setLoading", false)
                this.usersListDialog = false
              })
              .catch(err => {
                this.$store.dispatch('setError', err)
                this.$store.dispatch("setLoading", false)
                console.log(err)
              })
        },
        fetchLastActiveContact() {
          let lastActiveNumber = this.numberConfiguration.lastActiveContact
          if (lastActiveNumber !== '') {
            let db = this.$store.state.db
            let contactRef = doc(db, 'users', this.user.uid + '/provisionedNumbers/' + this.phoneNumber + '/sms/' + lastActiveNumber)
            return getDoc(contactRef)
                .then(dbRes => {
                  if (dbRes.exists) {
                    this.lastActiveContact = dbRes.data()
                  }
                })
            // quary numbers collection by phonenumber
            // fetch user details
            // set user details to this.lastActiveContact
          }
        },
        dialPadNumber (phoneNumber) {
          this.numberFromDialPad = phoneNumber
        },
        dialPadAction () {
          this.addNewContactDialog = true
          this.dialPadDialog = false
          this.randomNumber = this.numberFromDialPad
        },
        removeImageLink () {
          this.mediaUrl = undefined
        },
        addImageLink (link){
          console.log(link)
          this.mediaUrl = link
        },
        cancelImageUpload () {
          this.imageUploadDialog = false
          this.mediaUrl = undefined
        },
        // in progress
        selectImgFromContent (link) {
          this.mediaUrl = link
          console.log(link)
        },
        saveImageUrl (link) {
          this.imageUrl = link
          this.addImageToCollection()
        },
        addImageToCollection () {
          let contentRef = this.$store.state.db.collection('content')
          contentRef.add({created: Date.now(), imageUrl: this.imageUrl, type: "image"})
              .then(() => {
                this.loadContent()
              })
              .catch(err => {
                this.$store.dispatch('setError', err)
              })
        },
        loadContent() {
          this.imageUploadDialog = true
          // let contentRef = this.$store.state.db.collection('content')
          // contentRef.get()
          //     .then(res => {
          //       let content = []
          //       res.docs.forEach(doc => {
          //         content.push(doc.data())
          //       })
          //       this.content = content
          //     })
        },
        testFunction () {
          let db = this.$store.state.db
          let numberRef = doc(db, 'twilioNumbers', '+12892789876')
          return getDoc(numberRef)
              .then(dbRes => {
                if (dbRes.exists) {
                  let userID = dbRes.data().ownerId
                  console.log(userID)
                }
              })
        },
        // pre conversion phase
          routeToOrder (orderId) {
          //this.$router.push('/sale/' + orderId + '/?panel=client')
          this.$router.push('/booking/' + orderId)
        },
          onDismissed () {
              this.$store.dispatch('clearError')
          },

          addScheduleDate (msg) {
              this.$store.dispatch('setLoading', true)
              let scheduleRef = this.$store.state.admin.firestore().collection('scheduling').doc(this.id)
              let date
              let formattedDate
              if (msg.dialogFlowAgent.response.outputContexts[0].parameters.fields["date-time"].structValue.fields.date_time) {
                  date = msg.dialogFlowAgent.response.outputContexts[0].parameters.fields["date-time"].structValue.fields.date_time.stringValue
                  formattedDate = date.slice(0,10)
              }
              if (msg.dialogFlowAgent.response.outputContexts[0].parameters.fields["date-time"].structValue.fields.startDateTime) {
                  date = msg.dialogFlowAgent.response.outputContexts[0].parameters.fields["date-time"].structValue.fields.startDateTime.stringValue
                  formattedDate = date.slice(0,10)
              }
              scheduleRef.update({missionDate: formattedDate})
                  .then(() => {
                      this.$store.dispatch("setLoading", false)
                  })
                  .catch(err => {
                      this.$store.dispatch('setError', err)
                      this.$store.dispatch("setLoading", false)
                  })
          },
          addScheduleTime (msg) {
              this.$store.dispatch("setLoading", true)
              let scheduleRef = this.$store.state.admin.firestore().collection('scheduling').doc(this.id)
              let time
              let formattedTime
              if (msg.dialogFlowAgent.response.outputContexts[0].parameters.fields["date-time"].structValue.fields.date_time) {
                  time = msg.dialogFlowAgent.response.outputContexts[0].parameters.fields["date-time"].structValue.fields.date_time.stringValue
                  formattedTime = time.slice(11,16)
              }
              if (msg.dialogFlowAgent.response.outputContexts[0].parameters.fields["date-time"].structValue.fields.startDateTime) {
                  time = msg.dialogFlowAgent.response.outputContexts[0].parameters.fields["date-time"].structValue.fields.startDateTime.stringValue
                  formattedTime = time.slice(11,16)
              }

              scheduleRef.update({missionTime: formattedTime})
                  .then(() => {
                      this.$store.dispatch("setLoading", false)
                  })
                  .catch(err => {
                      this.$store.dispatch('setError', err)
                      this.$store.dispatch("setLoading", false)
                  })
          },

          saveNewlocation (value) {
              this.editLocation = false
              let userRef = this.$store.state.db.collection('SMS').doc(this.phoneNumber)
              userRef.update({meetupLocation: value})
          }
      }
    }
</script>
